import { TeamInfo } from 'modules/teams/domain/interfaces/team';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import React from 'react';
import { SymbolicTeamFormation } from 'modules/championship/domain/enums/symbolic-team-formation';
import { SelectedPlayer } from 'modules/championship/domain/interfaces/selected-player';
import { EmptyPlayersMessage } from './empty-players-message';
import { Player } from './player';
import { PayersListContent, PayersListWrapper } from './players-list.styles';

type PlayersListProps = {
  formation: SymbolicTeamFormation;
  allPlayers: TeamPlayer[];
  selectedPlayers: SelectedPlayer[];
  onPlayerSelect?: (player: TeamPlayer, team: TeamInfo) => void;
};

export const PlayersList = ({ formation, allPlayers, selectedPlayers, onPlayerSelect }: PlayersListProps) => {
  return (
    <PayersListWrapper>
      <PayersListContent>
        {!allPlayers.length && <EmptyPlayersMessage />}
        {allPlayers.map((player) => (
          <Player
            key={player.userId}
            team={player.team!}
            formation={formation}
            player={player}
            selectedPlayers={selectedPlayers}
            onPlayerSelect={onPlayerSelect}
          />
        ))}
      </PayersListContent>
    </PayersListWrapper>
  );
};
